module.exports = __webpack_public_path__ + "media/swimming_pool.db4e93e2.svg";